export default {
    locale: "العربية",
    mainSectionText1: "نحن نصنع تطبيقات قرآنية وبرمجيات أخرى",

    tajwidTagline1: "تطبيق معتمد من العلماء",
    tajwidTagline1Row2: "لتعلم",
    tajwidTagline1Bold: "التجويد بسهولة،",
    tajwidTagline1AfterBold: "يستخدمه ملايين حول العالم",

    textProductTajwid2: "الميزات التي تجعل من السهل عليك قراءة القرآن",
    poin1Tajwid: "فعال",
    poin2Tajwid: "عالي الجودة",
    poin3Tajwid: "فعال من حيث التكلفة",
    poin4Tajwid: "شامل",
    poin5Tajwid: "موثوق",
    learnMoreTajwid: "المزيد من المعلومات",

    qtvTagline1: "تطبيق",
    qtvTagline1Row2: "مصحف القرآن",
    qtvTagline1Bold: "الأفضل",
    qtvTagline1AfterBold: " لـمنصة التلفاز الذكي",
    qtvTagline1Row3: "إِنْ شَاءَ ٱللَّٰهُ !",

    learnMoreQtv: "المزيد من المعلومات",

    poin1Qtv: "تم إنشاؤه خصيصًا لمنصة التلفاز",
    poin2Qtv: "يمكن الوصول إليه دون اتصال بالإنترنت",
    poin3Qtv: "تم تحسينه للقراءة والعرض",
    poin4Qtv: "سهل الاستخدام",
    poin5Qtv: "سهل الاستخدام",
    poin6Qtv: "غني بالميزات",

    tafsirTagline1: "تطبيقات عالية الجودة",
    tafsirTagline1Row2: "لتعلم",
    tafsirTagline1Bold: "فهم",
    tafsirTagline1AfterBold: "القرآن",

    poin1Tafsir: "تنوع التفسير",
    poin2Tafsir: "عرض جذاب",
    poin3Tafsir: "ميزة البحث",
    poin4Tafsir: "جودة عالية",
    poin5Tafsir: "مصدر موثوق",
    poin6Tafsir: "في أي وقت، في أي مكان",

    learnMoreTafsir: "المزيد من المعلومات",

    impactUsers: "المستخدمون",
    impactUsers2: "إندونيسيا",
    impactCountries: "الدول",
    impactMinutesUsage: "دقائق الاستخدام",

    textAward1: "جوائز",
    textAward2: "جوائز",
    textAward3: "المركز الأول",
    textAward4: "التطبيق الأكثر ابتكارًا",

    textPublishedBy1: "تم النشر بواسطة",
    textPublishedBy2: "ووسائل الإعلام الأخرى...",

    textPartners1: "شركاؤنا",

    siteMapCol2Row1: "خدمات",
    siteMapCol2Row2: "إنشاء البرمجيات لك",
    siteMapCol2Row3: "التعلم مع معلم القرآن",
    siteMapCol2Row4: "حول مصحف القرآن",
    siteMapCol2Row5: "فرص العمل الخيري",
    siteMapCol2Row6: "المدونات",
    siteMapCol2Row7: "الإعلانات معنا",

    siteMapCol3Row1: "شركاؤنا",
    siteMapCol3Row2: "BAZNAS",
    siteMapCol3Row3: "BEKRAF",
    siteMapCol3Row4: "Code Margonda",
    siteMapCol3Row5: "FUSI Foundation",

    siteMapCol4Row1: "المنتجات",
    siteMapCol4Row2: "Learn Quran Tajwid",
    siteMapCol4Row3: "Learn Quran Tafsir",
    siteMapCol4Row4: "Quran Mushaf Apps",
    siteMapCol4Row5: "LQTafsir Android",
    siteMapCol4Row5B: "LQTafsir iOS",
    siteMapCol4Row6: "Quran Mushaf Android TV",
    siteMapCol4Row7: "Quran Mushaf Fire TV",
    siteMapCol4Row8: "Quran Mushaf Samsung TV",

    siteMapCol5Row1: "الحسابات الرسمية",

    textCopyright1: "حقوق النشر",

    textService: "نحن نقدم أيضًا خدمات تطوير البرمجيات",
};